import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  MenuItem,
  FormControl,
  Select,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import apiClient from "../../../utils/apiClient";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InfoNote from "../InfoNote";

// ----------------------------------
// Styled Domain Card
// ----------------------------------
const DomainCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: "16px",
  backgroundColor: alpha("#FFFFFF", 0.9),
  backdropFilter: "blur(8px)",
  boxShadow:
    "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
  textAlign: "center",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  cursor: "pointer",

  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  },
}));

// ----------------------------------
// Dummy Domain Data
// ----------------------------------
const icons = ["✏️", "💰", "📢", "🛡️", "</>"];

const StrongDomainsPageForRest = () => {
  const [streams, setStreams] = useState([]);
  const [domains, setDomains] = useState([]);
  const [shuffleType, setShuffleType] = useState("");

  const [preference, setPreference] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [recommendedStreams, setRecommendedStreams] = useState([]);
  const [checkingStatus, setCheckingStatus] = useState(true);
  const [allStreams, setAllStreams] = useState([]);
  const [chosenStream, setChosenStream] = useState([]);
  const [loadingDomains, setLoadingDomains] = useState(false);
  const [chosenBoard, setChosenBoard] = useState([]);
  const [allBoards, setAllBoards] = useState([]);
  const [boardStreams, setBoardStreams] = useState([]);
  const [openDomainSelect, setOpenDomainSelect] = useState(false);
  const [selectedDomains, setSelectedDomains] = useState([]);

  const navigate = useNavigate();

  const [allDomainsForConfusion, setAllDomainsForConfusion] = useState([]);

  useEffect(() => {
    const fetchSeniorSecondaryDomains = async () => {
      try {
        const res = await apiClient.get(
          "/counselling/all-senior-secondary-domains",
          {
            method: "GET",
            credentials: "include", // keep this if you use cookies/JWT
          },
        );

        const data = await res.data;

        if (data.success) {
          setAllDomainsForConfusion(data.data);
        } else {
          console.error("Failed to fetch domains");
        }
      } catch (error) {
        console.error("Error fetching senior secondary domains:", error);
      }
    };

    fetchSeniorSecondaryDomains();
  }, []);

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await apiClient.get(
          "/counselling/streams/from-stream-domain-yt",
        );
        // console.log(response);
        if (response?.data?.success) {
          setAllStreams(response.data.data);
        }
      } catch (error) {
        console.error("Failed to find all streams:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchStreams();
  }, []);

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await apiClient.get("/counselling/all-boards");
        // console.log(response);
        if (response?.data?.success) {
          setAllBoards(response.data.data);
        }
      } catch (error) {
        console.error("Failed to find all streams:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchBoards();
  }, []);

  const fetchStreamDomains = async (selectedStream) => {
    try {
      setLoadingDomains(true);
      setChosenStream(selectedStream);

      const response = await apiClient.get(
        `/counselling/domains/by-stream/${selectedStream.stream_id}`,
      );
      // console.log(response);

      // const domainMap = {};

      // Object.values(response.data.data).forEach((arr) => {
      //   arr.forEach((d) => {
      //     domainMap[d.domain_id] = d;
      //   });
      // });
      if (response.data.success) setDomains(response.data.data);
    } finally {
      setLoadingDomains(false);
    }
  };

  const fetchBoardStreams = async (selectedBoard) => {
    try {
      setLoadingDomains(true);
      setChosenBoard(selectedBoard);

      const response = await apiClient.get(
        `/counselling/streams/by-board/${selectedBoard.board_id}`,
      );
      // console.log(response);

      // const domainMap = {};

      // Object.values(response.data.data).forEach((arr) => {
      //   arr.forEach((d) => {
      //     domainMap[d.domain_id] = d;
      //   });
      // });
      if (response.data.success) {
        setBoardStreams(response.data.data);
      }
    } finally {
      setLoadingDomains(false);
    }
  };
  useEffect(() => {
    const checkBuyStatus = async () => {
      try {
        const response = await apiClient.get("/counselling/buyStatus");
        console.log(response);
        if (response?.data?.success) {
          if (response.data.boughtStatus === false) {
            navigate("/counselling-checkout");
          }
        }
      } catch (error) {
        console.error("Failed to check counselling buy status:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkBuyStatus();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // ---------------- STREAMS ----------------
      const marksRes = await apiClient.get("/counselling/domains");
      // console.log(marksRes);

      const topDomains = [...marksRes.data.data.domains].slice(0, 3);

      const domainIds = topDomains.map((s) => s.domain_id);

      if (domainIds && topDomains.length > 0) {
        // const rankingRes = await apiClient.post(
        //   "/counselling/stream-rankings",
        //   {
        //     stream_ids: streamIds,
        //   },
        // );

        // const mergedStreams = topStreams.map((s) => ({
        //   ...s,
        //   ...rankingRes.data.data.find((r) => r.stream_id === s.stream_id),
        // }));

        setStreams(topDomains);

        // ---------------- DOMAINS ----------------
        // const domainRes = await apiClient.get(
        //   `/counselling/stream-domains?stream_ids=${streamIds.join(",")}`,
        // );

        // // Flatten & deduplicate domains
        // const domainMap = {};
        // Object.values(domainRes.data.data).forEach((arr) => {
        //   arr.forEach((d) => {
        //     domainMap[d.domain_id] = d;
        //   });
        // });

        // setDomains(Object.values(domainMap));
      } else {
        alert("Some error occured!!");
      }
    };

    fetchData();
  }, []);

  // ----------------------------------
  // Shuffle Logic
  // ----------------------------------

  const calculateScore = (stream, type) => {
    const m = stream.market_scope_ranking;
    const e = stream.economic_investment_ranking;
    const mo = stream.motivation_ranking;

    switch (type) {
      case "Market Scope":
        return m;
      case "Economic Investment":
        return e;
      case "Motivation":
        return mo;
      case "Market Scope + Economic Investment":
        return (m + e) / 2;
      case "Market Scope + Motivation":
        return (m + mo) / 2;
      case "Economic Investment + Motivation":
        return (e + mo) / 2;
      case "Market Scope + Economic Investment + Motivation":
        return (m + e + mo) / 3;
      default:
        return 0;
    }
  };

  const handleShuffle = (category) => {
    setShuffleType(category);

    // streams.map((s) => {
    //   // console.log(s);
    //   // console.log(`${s.stream_name} Score`, calculateScore(s, category));
    // });

    //Real logic
    // const shuffled = [...streams].sort(
    //   (a, b) => calculateScore(b, category) - calculateScore(a, category),
    // );

    //Random logic
    const shuffled = [...streams];

    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    setStreams(shuffled);
  };

  // ----------------------------------
  // Navigate to Aptitude Page (you will add routing later)
  // ----------------------------------
  const handleTest = (domain) => {
    console.log("Navigate to aptitude test for:", domain);
  };

  const handleRecommendation = () => {
    if (!preference) return;

    if (preference === "decide") {
      setRecommendedStreams([streams[0]]);
      setOpenDialog(true);
    }

    if (preference === "some") {
      // Open domain selection dialog instead
      setOpenDomainSelect(true);
    }

    if (preference === "decided") {
      setRecommendedStreams(streams.slice(0, 3));
      setOpenDialog(true);
    }
  };

  const handleFinalRecommendation = () => {
    // Find best ranked domain among selected

    if (selectedDomains.length > 0) {
      const randomIndex = Math.floor(Math.random() * selectedDomains.length);
      setRecommendedStreams([selectedDomains[randomIndex]]);
    }
    setOpenDomainSelect(false);
    setOpenDialog(true);
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* ----------------- HEADER ----------------- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 4,
          mb: 3,
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          sx={{ fontFamily: "Aclonica" }}
        >
          Strong Domains:
        </Typography>

        <FormControl sx={{ minWidth: 180 }}>
          <Select
            value={shuffleType}
            onChange={(e) => handleShuffle(e.target.value)}
            displayEmpty
            sx={{
              borderRadius: "12px",
              background: "#fff",
              height: "40px",
              fontWeight: 600,
            }}
          >
            <MenuItem disabled value="">
              Shuffle By
            </MenuItem>
            <MenuItem value="Market Scope">Market Scope</MenuItem>
            <MenuItem value="Economic Investment">Economic Investment</MenuItem>
            <MenuItem value="Motivation">Motivation</MenuItem>
            <MenuItem value="Market Scope + Economic Investment">
              Market Scope + Economic Investment
            </MenuItem>
            <MenuItem value="Market Scope + Motivation">
              Market Scope + Motivation
            </MenuItem>
            <MenuItem value="Economic Investment + Motivation">
              Economic Investment + Motivation
            </MenuItem>
            <MenuItem value="Market Scope + Economic Investment + Motivation">
              Market Scope + Economic Investment + Motivation
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* ----------------- DOMAIN CARDS ----------------- */}
      <Grid container spacing={3}>
        {streams.map((stream, index) => (
          <Grid item xs={12} sm={6} md={4} key={stream.domain_id}>
            <DomainCard>
              <Typography fontSize="40px">
                {icons[(icons.length + index) % icons.length]}
              </Typography>
              <Typography fontSize="1.3rem" fontWeight={600} mt={1} mb={2}>
                {stream.domain}
              </Typography>

              {/* <Typography fontSize="0.9rem" mb={2}>
                Score: {Math.round(stream.marks)}
              </Typography> */}

              <Button
                variant="contained"
                onClick={() => handleTest(stream.domain_id)}
              >
                Explore Stream
              </Button>
            </DomainCard>
          </Grid>
        ))}
      </Grid>
      <InfoNote text="Virtual Reality and project-based final decisions will also be added soon." />
      <Box sx={{ mt: 6 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginBottom: "10px",
          }}
        >
          <Typography
            variant="h5"
            fontWeight={600}
            mb={3}
            sx={{ fontFamily: "Poppins" }}
          >
            Streams that you can explore related to a board
          </Typography>
          <FormControl sx={{ minWidth: 180 }}>
            <Select
              value={chosenBoard?.board_id || ""}
              onChange={(e) => {
                const selected = allBoards.find(
                  (s) => s.board_id === e.target.value,
                );
                fetchBoardStreams(selected);
              }}
              displayEmpty
              sx={{
                borderRadius: "12px",
                background: "#fff",
                height: "40px",
                fontWeight: 600,
              }}
            >
              <MenuItem disabled value="">
                Choose Board
              </MenuItem>

              {allBoards.map((s) => (
                <MenuItem key={s.board_id} value={s.board_id}>
                  {s.board}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Grid container spacing={3}>
          {boardStreams.map((st) => (
            <Grid item xs={12} sm={6} md={4} key={st.stream_id}>
              <DomainCard>
                <Typography fontWeight={600} fontSize="1.1rem">
                  {st.stream}
                </Typography>

                <IconButton
                  sx={{ mt: 2 }}
                  color="error"
                  onClick={() =>
                    window.open(
                      st.youtube_link
                        ? st.youtube_link
                        : `https://www.youtube.com/results?search_query=${encodeURIComponent(
                            st.stream + " career",
                          )}`,
                      "_blank",
                    )
                  }
                >
                  <YouTubeIcon fontSize="large" />
                </IconButton>
              </DomainCard>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* ================= WORKFORCE DOMAINS ================= */}
      <Box sx={{ mt: 6 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginBottom: "10px",
          }}
        >
          <Typography
            variant="h5"
            fontWeight={600}
            mb={3}
            sx={{ fontFamily: "Poppins" }}
          >
            Workforce domains that you can explore related to a stream
          </Typography>
          <FormControl sx={{ minWidth: 180 }}>
            <Select
              value={chosenStream?.stream_id || ""}
              onChange={(e) => {
                const selected = allStreams.find(
                  (s) => s.stream_id === e.target.value,
                );
                fetchStreamDomains(selected);
              }}
              displayEmpty
              sx={{
                borderRadius: "12px",
                background: "#fff",
                height: "40px",
                fontWeight: 600,
              }}
            >
              <MenuItem disabled value="">
                Choose stream
              </MenuItem>

              {allStreams.map((s) => (
                <MenuItem key={s.stream_id} value={s.stream_id}>
                  {s.stream}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Grid container spacing={3}>
          {domains.map((domain) => (
            <Grid item xs={12} sm={6} md={4} key={domain.domain_id}>
              <DomainCard>
                <Typography fontWeight={600} fontSize="1.1rem">
                  {domain.domain}
                </Typography>

                <IconButton
                  sx={{ mt: 2 }}
                  color="error"
                  onClick={() =>
                    window.open(
                      domain.youtube_link
                        ? domain.youtube_link
                        : `https://www.youtube.com/results?search_query=${encodeURIComponent(
                            domain.domain + " career",
                          )}`,
                      "_blank",
                    )
                  }
                >
                  <YouTubeIcon fontSize="large" />
                </IconButton>
              </DomainCard>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* Here all the streams */}
      {/* <Box sx={{ mt: 6 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h5"
            fontWeight={600}
            mb={3}
            sx={{ fontFamily: "Poppins" }}
          >
            Here are all the explorable streams
          </Typography>
          
        </Box>

        <Grid container spacing={3}>
          {allStreams.map((s) => (
            <Grid item xs={12} sm={6} md={4} key={s.stream}>
              <DomainCard>
                <Typography fontWeight={600} fontSize="1.1rem">
                  {s.stream}
                </Typography>

                <IconButton
                  sx={{ mt: 2 }}
                  color="error"
                  onClick={() =>
                    window.open(
                      `https://www.youtube.com/results?search_query=${encodeURIComponent(
                        s.stream + " career",
                      )}`,
                      "_blank",
                    )
                  }
                >
                  <YouTubeIcon fontSize="large" />
                </IconButton>
              </DomainCard>
            </Grid>
          ))}
        </Grid>
      </Box> */}
      {/* ================= POSTMORTEM QUESTION ================= */}
      <Typography
        variant="h5"
        fontSize={"24px"}
        fontWeight={600}
        mb={0}
        mt={8}
        sx={{ backgroundColor: "#fff", padding: "10px", borderRadius: "15px" }}
      >
        This is your personalized and customized postmortem of career options.
        What do you prefer?
      </Typography>
      <Box sx={{ mt: 2, backgroundColor: "#fff", p: 3, borderRadius: "20px" }}>
        <Typography variant="h5" fontWeight={600} mb={2}>
          For Main Domains
        </Typography>

        <FormControl>
          <RadioGroup
            value={preference}
            onChange={(e) => setPreference(e.target.value)}
          >
            <FormControlLabel
              value="decide"
              control={<Radio />}
              label="You want us to completely decide for you"
            />
            <FormControlLabel
              value="some"
              control={<Radio />}
              label="You have some domains in mind and want to decide one from them"
            />
            <FormControlLabel
              value="decided"
              control={<Radio />}
              label="You have already decided and want further evaluation and clarity"
            />
          </RadioGroup>
        </FormControl>

        <Box mt={3}>
          <Button
            variant="contained"
            disabled={!preference}
            onClick={handleRecommendation}
            sx={{
              backgroundColor: "#30B0C7",
              borderRadius: "100px",
              px: 4,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            See Recommendation
          </Button>
        </Box>
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Your Domain Recommendation
        </DialogTitle>

        <DialogContent>
          <Typography mb={2}>
            Based on your preference, we recommend:
          </Typography>

          {recommendedStreams.map((s) => (
            <Typography key={s.domain_id} fontWeight={600} sx={{ mt: 1 }}>
              • {s.domain}
            </Typography>
          ))}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={() => setOpenDialog(false)}>
            Close
          </Button>

          <Button
            variant="contained"
            onClick={() => navigate("/AI/dashboard")}
            sx={{ backgroundColor: "#30B0C7" }}
          >
            Go to Post Counselling
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDomainSelect}
        onClose={() => setOpenDomainSelect(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Which domains are you confused between?
        </DialogTitle>

        <DialogContent>
          <Typography mb={2}>Select all that apply:</Typography>

          {allDomainsForConfusion.map((domain) => (
            <FormControlLabel
              key={domain.domain_id}
              control={
                <Checkbox
                  checked={selectedDomains.some(
                    (d) => d.domain_id === domain.domain_id,
                  )}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedDomains([...selectedDomains, domain]);
                    } else {
                      setSelectedDomains(
                        selectedDomains.filter(
                          (d) => d.domain_id !== domain.domain_id,
                        ),
                      );
                    }
                  }}
                />
              }
              label={domain.domain}
            />
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDomainSelect(false)}>Cancel</Button>

          <Button
            variant="contained"
            disabled={selectedDomains.length < 2}
            sx={{ backgroundColor: "#30B0C7" }}
            onClick={handleFinalRecommendation}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StrongDomainsPageForRest;
